import { motion } from "framer-motion";

import C1 from "../assets/images/clientes/c1.png"
import C2 from "../assets/images/clientes/c2.png"
import C3 from "../assets/images/clientes/c3.png"
import C4 from "../assets/images/clientes/c4.png"
import C5 from "../assets/images/clientes/c5.png"
import C6 from "../assets/images/clientes/c6.png"
import C7 from "../assets/images/clientes/c7.png"
import C8 from "../assets/images/clientes/c8.png"
import C9 from "../assets/images/clientes/c9.png"
import C10 from "../assets/images/clientes/c10.png"
import C11 from "../assets/images/clientes/c11.png"
import C12 from "../assets/images/clientes/c12.png"
import C13 from "../assets/images/clientes/c13.png"
import C14 from "../assets/images/clientes/c14.png"
import C15 from "../assets/images/clientes/c15.png"
import C16 from "../assets/images/clientes/c16.png"
import C17 from "../assets/images/clientes/c17.png"
import C18 from "../assets/images/clientes/c18.png"
import C19 from "../assets/images/clientes/c19.png"
import C20 from "../assets/images/clientes/c20.png"
import C21 from "../assets/images/clientes/c21.png"
const logos = [
C1,C2,C3,C4,C5,C6,C7,C8,C9,C10,C11,C12,C13,C14,C15,C16,C17,C18,C19,C20,C21

];

export default function ClientesCarousel() {
  return (
    <div className="overflow-hidden bg-gris-claro py-6 rounded-lg shadow-lg">
      <div className="relative flex items-center justify-center">
        {/* Icono de flechas */}
        <div className="absolute left-0 z-10 text-azul-oscuro text-4xl font-bold"></div>

        {/* Carrusel de logos */}
        <motion.div
          className="flex space-x-10 w-max"
          animate={{ x: ["0%", "-100%"] }}
          transition={{
            repeat: Infinity,
            duration: 15,
            ease: "linear",
          }}
        >
          {[...logos, ...logos].map((src, index) => (
            <img key={index} src={src} alt={`logo-${index}`} className="h-16 w-auto object-contain " />
          ))}
        </motion.div>
      </div>
    </div>
  );
}
